import { render, staticRenderFns } from "./ReviewIndex.vue?vue&type=template&id=a4001c3a&scoped=true&"
import script from "./ReviewIndex.vue?vue&type=script&lang=js&"
export * from "./ReviewIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReviewIndex.vue?vue&type=style&index=0&id=a4001c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4001c3a",
  null
  
)

export default component.exports